import { render, staticRenderFns } from "./score-rating.component.vue?vue&type=template&id=3d2cce7f"
import script from "./score-rating.component.ts?vue&type=script&lang=ts&external"
export * from "./score-rating.component.ts?vue&type=script&lang=ts&external"
import style0 from "./score-rating.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports